import i18n from '@/utils/i18n';
import dataMixin from './dataMixin'
import computedMixin from './computedMixin'
import methodsMixin from './methodsMixin'
export default {
  data() {
    return {
      ...dataMixin
    }
  },
  computed: {
    ...computedMixin
  },
  methods: {
    ...methodsMixin
  }
}

